<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.webhook.field.url') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ url_ip: true, required: true }">
            <i-input v-model="form.url" placeholder="URI" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.webhook.field.type') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ required: !disabled && active }">
            <select-type
              v-model="form.type"
              :items="items"
              :disabled="disabled"
              @repeated="repeated"
            />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>
    <i-button
      v-if="!repeat || !uri"
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      :disabled="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
    <template v-if="repeat && uri" slot="footer-cancel" slot-scope="{ close }">
      <i-button size="large" @click="close()">
        {{ $t('shared.component.button.cancel') }}
      </i-button>
      <i-button size="large" type="success" @click="close()">
        {{ $t('shared.component.button.save') }}
      </i-button>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import SelectType from './webhook-filter-type';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';
  import { WebhookService } from '@autocaller_v2/services/WebhookService';
  import { mapGetters } from 'vuex';
  import { TOTAL_ITEMS } from '@app/plugins/vuex-async-pagginate';

  export default {
    components: {
      BaseModal,
      SelectType
    },

    props: {
      id: {
        type: [Number, String],
        default: null
      },

      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {},
      items: [],
      repeat: false,
      active: true,
      is_button_loading: false
    }),

    computed: {
      ...mapGetters('autocaller_v2/webhook/table', { total_items: TOTAL_ITEMS }),
      disabled() {
        return this.total_items == 16;
      },
      uri() {
        return this.item.url == this.form.url
      }
    },

    watch: {
      item: {
        handler: function(val) {
          this.form = defaultsDeep(pick(val, ['url', 'type']), {
            url: '',
            type: ''
          });
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      repeated(val) {
        this.repeat = val;
      },
      save: function() {
        if(!this.uri && this.repeat) {
          delete this.form.type;
          this.active = false
        }
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_button_loading = true;

            const request = this.id
              ? WebhookService.editItem(this.id, this.form)
              : WebhookService.createItem(this.form);
            request
              .then(res => this.$emit('success', res))
              .catch(e => {
                this.$noty.server_error(e);
                this.$emit('fail', e);
              })
          }
        });
      }
    }
  };
</script>
